<template>
  <!-- eslint-disable -->
  <svg
    version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 105.9 100" style="enable-background: new 0 0 105.9 100;" xml:space="preserve"
  >
    <g>
      <path
        style="fill: #193e4f;" d="M33.4,52.2l4.4-27.9c-1.7,0-4.7,0-4.7,0c-2.2,0-5.1-1.2-5.9-3.5c-0.3-0.8-0.9-3.4,2.7-6
        c1.3-0.9,2.1-1.9,2.3-2.7c0.2-0.8,0-1.5-0.6-2c-0.8-0.8-2.4-1.2-4.4-1.2c-3.4,0-5.8,1.9-6,3.3c-0.2,1,0.6,1.9,1.3,2.4
        c2.1,1.6,2.6,3.9,1.3,6c-1.3,2.2-4.3,3.6-7.4,3.7c0,0-3.1,0-4.8,0c-0.4,2.7-7,44.3-7.5,47.6h26.1C30.5,70.5,31.7,62.6,33.4,52.2
        L33.4,52.2z"
      />
      <g>
        <path
          style="fill: #193e4f;" d="M2.8,81.6h10.7c4.6,0,5.7,2.3,5.3,4.4c-0.3,1.7-1.4,3-3.4,3.8c2.5,1,3.5,2.5,3.2,4.9
          c-0.5,3-3,5.2-6.4,5.2H0L2.8,81.6z M9.9,89.1c2.1,0,3-1.1,3.2-2.4c0.2-1.4-0.4-2.4-2.5-2.4H8.8l-0.7,4.8L9.9,89.1L9.9,89.1z
           M8.8,97c2.1,0,3.4-0.9,3.7-2.6c0.2-1.5-0.6-2.4-2.7-2.4H7.7L6.9,97L8.8,97L8.8,97z"
        />
        <path
          style="fill: #193e4f;" d="M33.6,100c-2.8,0.2-4.1-0.1-4.8-1.3c-1.5,0.9-3.1,1.4-4.9,1.4c-3.1,0-4.3-1.6-4-3.4
          c0.1-0.9,0.6-1.7,1.4-2.4c1.7-1.5,6-1.7,7.7-2.8c0.1-1.3-0.4-1.7-1.9-1.7c-1.8,0-3.4,0.6-6,2.4l0.6-4.2c2.3-1.6,4.5-2.4,7-2.4
          c3.2,0,6.1,1.3,5.6,4.9l-0.6,4c-0.2,1.4-0.2,1.8,1.4,1.9L33.6,100z M28.7,93.7c-1.5,0.9-4.2,0.8-4.5,2.7c-0.1,0.9,0.4,1.6,1.3,1.6
          c0.9,0,1.9-0.4,2.8-1c-0.1-0.3,0-0.7,0.1-1.3L28.7,93.7z"
        />
        <path
          style="fill: #193e4f;" d="M38.7,85.7h5.6L44,87.5c1.8-1.5,3.1-2.1,4.9-2.1c3.1,0,4.6,1.9,4.1,5l-1.4,9.3h-5.6l1.2-7.7
          c0.2-1.4-0.2-2.1-1.3-2.1c-0.9,0-1.7,0.5-2.4,1.5l-1.3,8.3h-5.6L38.7,85.7z"
        />
        <path style="fill: #193e4f;" d="M57.3,81.6h5.6l-1.4,9l5.3-4.9h6.9l-6.8,6l5.5,8.1h-7L61,93.3H61l-1,6.5h-5.6L57.3,81.6z" />
      </g>
      <path style="fill: #193e4f;" d="M76.9,81.6h6.4l-2.8,18.2h-6.4L76.9,81.6z" />
      <path
        style="fill: #193e4f;" d="M86.4,81.6h9.1c7.1,0,9.1,5.1,8.4,9.4c-0.6,4.2-3.9,8.9-10.1,8.9H83.6L86.4,81.6z M92.3,95.5
        c3.1,0,4.8-1.5,5.3-4.8c0.4-2.4-0.4-4.8-3.8-4.8h-1.7l-1.5,9.6L92.3,95.5L92.3,95.5z"
      />
      <path
        style="fill: #193e4f;" d="M68.4,0H41.8l-3.5,22.5h4.5c2.5,0,4.8-1.1,5.8-2.8c0.3-0.5,0.5-1,0.5-1.4c0-0.9-0.6-1.6-1.3-2.1
        c-1.7-1.3-2.1-2.7-2.1-3.6c0-0.2,0-0.4,0-0.5c0.4-2.4,3.6-5,7.8-5c2.5,0,4.5,0.6,5.7,1.7c1,1,1.4,2.3,1.1,3.8
        c-0.4,1.7-2.1,3.1-3,3.8c-2.6,1.8-2.2,3.4-2.1,3.9c0.5,1.4,2.6,2.3,4.2,2.3h6.9c0,0,0,0,0,0C75.6,22.6,80.7,27,79.1,37
        c-1.5,9.3-8.6,13.4-17.2,13.4L58.5,72h5c21.1,0,38.3-13.5,41.7-34.9C109.4,10.6,92.5,0,68.4,0z"
      />
    </g>
  </svg>
  <!-- eslint-enable -->
</template>

<script>
  export default {
    name: 'BankIdSE'
  }
</script>
